/** @package */
export const PYTHON_STARTER_CODE = `
"""
Supported packages:

allotropy
biopython
lmfit
matplotlib
numpy
openpyxl
pandas
plotly
pyarrow
pydantic
seaborn
scikit-learn
scipy
statsmodels
"""
from io import BytesIO
import pandas as pd
from typing import NamedTuple
import plotly.graph_objects as go

class IOData(NamedTuple):
    name: str
    data: BytesIO | pd.DataFrame | go.Figure

def custom_code(inputs: list[IOData], **kwargs) -> list[IOData]:
    raise NotImplementedError("TODO: Return list of IOData")
`;
